import h from 'react-hyperscript';

import PropTypes from 'prop-types';
import styles from './testimonials-grid.css';

// Set columns as an array so that it can eventually be mapped
// over during render.
// NOTE: could probs move this to props if needed
const columns = [1, 2, 3];

const TestimonialsGrid = ({ testimonials }) => {
  const unitsPerColumn = Math.ceil(testimonials.length / columns.length);
  
  const grid = columns.map(c => {
    const startIndex = (c - 1) * unitsPerColumn;
    const endIndex = startIndex + unitsPerColumn;
    return h('li', {className: styles.testimonialContainer},
      testimonials.slice(startIndex, endIndex).map( t => 
        h('div', {className: styles.testimonial}, [
          h('blockquote', t.quote),
          t.author ? h('span', {className: styles.author}, t.author) : undefined
        ])
      )
    );
  });
  
  return h('ul', { className: styles.testimonialsGrid }, grid);
};

TestimonialsGrid.defaultProps = {
    testimonials: []
};

TestimonialsGrid.propTypes = {
    testimonials: PropTypes.arrayOf(
        PropTypes.shape({
            author: PropTypes.string.isRequired,
            quote: PropTypes.string.isRequired,
            authorDetail: PropTypes.string
        })
    ).isRequired
};

export default TestimonialsGrid;



/** WEBPACK FOOTER **
 ** ./src/TestimonialsGrid/index.js
 **/